// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cI-z","carouselContainer":"dI-z"};